import { Formik, useFormik } from 'formik';
import React from 'react';
import { Form, Row, Col, Button, FormControl } from 'react-bootstrap';
import * as yup from 'yup';

const fieldSchema = yup.object().shape({
  key: yup.string().required('Key is required'),
  english: yup.string().required('English Name is required'),
  hebrew: yup.string().required('Hebrew Name is required'),
  description: yup.string().optional()
});

const AddEditCalculatorForm = ({ initialValues, onSubmit, translate, isGroup = false }) => {
  const { handleChange, handleSubmit, values, errors } = useFormik({
    initialValues,
    onSubmit: values => {
      const formData = {
        ...values,
        key: values.key || initialValues.key,
        english: values.english || initialValues.english,
        hebrew: values.hebrew || initialValues.hebrew,
        description: values.description
      };
      onSubmit(formData);
    },
    validationSchema: fieldSchema
  });

  return (
    <Formik initialValues={initialValues} validationSchema={fieldSchema}>
      <Form
        onSubmit={e => {
          e.preventDefault();
          handleSubmit(e);
        }}
      >
        <Row>
          <Col xs={12}>
            <Form.Group>
              <h6 className="smallFont fw-bold">{translate('english_name')}</h6>
              <FormControl
                size="sm"
                className="mb-2"
                type="text"
                name="english"
                value={values.english}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>
          <Col xs={12}>
            <Form.Group>
              <h6 className="smallFont fw-bold">{translate('hebrew_name')}</h6>
              <FormControl
                size="sm"
                className="mb-2"
                type="text"
                name="hebrew"
                value={values.hebrew}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>
          {!isGroup && (
            <Col xs={12}>
              <Form.Group>
                <h6 className="smallFont fw-bold">{translate('description')}</h6>
                <FormControl
                  size="sm"
                  className="mb-2"
                  type="text"
                  name="description"
                  value={values.description}
                  onChange={handleChange}
                  as="textarea"
                  rows={3}
                />
              </Form.Group>
            </Col>
          )}

          <Col xs={12}>
            <h6 className="smallFont fw-bold text-danger">{errors?.key || errors?.english || errors?.hebrew}</h6>
          </Col>
          <Col xs={12} className="d-flex justify-content-end mt-2">
            <Button size="sm" variant="success text-white" type="submit">
              {translate('update')}
            </Button>
          </Col>
        </Row>
      </Form>
    </Formik>
  );
};

export default AddEditCalculatorForm;
